import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Reembolso } from '../../model/turismo/reembolso.model';

// Interface para a resposta paginada da API
export interface RespostaPaginadaReembolsos {
  MetaData: {
    TotalPaginas: number;
    TotalItens: number;
    NumeroPagina: number;
    ItensPorPagina: number;
    MetaDados: string | null;
  };
  Items: Reembolso[];
}

const TURISMO = environment.TURISMO;
const ITENSPORPAGINA = environment.ITENSPORPAGINA;

@Injectable()
export class ReembolsoService {
    constructor(private http: HttpClient) { }

    /**
     * Busca reembolsos por cliente com paginação
     * @param idCliente ID do cliente
     * @param pagina Número da página
     * @param itensPorPagina Quantidade de itens por página
     * @returns Observable com lista paginada de reembolsos
     */
    buscarReembolsos(idCliente: number, pagina: number = 1, itensPorPagina: number = ITENSPORPAGINA): Observable<RespostaPaginadaReembolsos> {
        const headers = new HttpHeaders().set('noloader', 't');
        return this.http.get<RespostaPaginadaReembolsos>(
            `${TURISMO}/api/Reembolso/BuscarOnasys/${idCliente}?pagina=${pagina}&itensPorPagina=${itensPorPagina}`,
            { headers: headers }
        );
    }

    /**
     * Busca reembolsos com filtros adicionais
     * @param idCliente ID do cliente
     * @param pagina Número da página
     * @param itensPorPagina Quantidade de itens por página
     * @param filtros Filtros adicionais (opcional)
     * @returns Observable com lista paginada de reembolsos
     */
    buscarReembolsosComFiltros(
        idCliente: number, 
        pagina: number = 1, 
        itensPorPagina: number = ITENSPORPAGINA,
        filtros?: any
    ): Observable<RespostaPaginadaReembolsos> {
        const headers = new HttpHeaders().set('noloader', 't');
        let url = `${TURISMO}/api/Reembolso/BuscarOnasys/${idCliente}?pagina=${pagina}&itensPorPagina=${itensPorPagina}`;
        
        // Adicionar filtros se fornecidos
        if (filtros) {
            Object.keys(filtros).forEach(key => {
                if (filtros[key] !== null && filtros[key] !== undefined && filtros[key] !== '') {
                    url += `&${key}=${encodeURIComponent(filtros[key])}`;
                }
            });
        }
        
        return this.http.get<RespostaPaginadaReembolsos>(url, { headers: headers });
    }

    /**
     * Busca reembolsos por parâmetro de busca (localizador, nome do passageiro, fornecedor)
     * @param idCliente ID do cliente
     * @param parametroBusca Parâmetro de busca
     * @param pagina Número da página
     * @param itensPorPagina Quantidade de itens por página
     * @returns Observable com lista paginada de reembolsos
     */
    buscarReembolsosPorParametro(
        idCliente: number,
        parametroBusca: string,
        pagina: number = 1,
        itensPorPagina: number = ITENSPORPAGINA
    ): Observable<RespostaPaginadaReembolsos> {
        const headers = new HttpHeaders().set('noloader', 't');
        
        if (parametroBusca && parametroBusca.trim().length > 0) {
            return this.http.get<RespostaPaginadaReembolsos>(
                `${TURISMO}/api/Reembolso/BuscarOnasys/${idCliente}?pagina=${pagina}&itensPorPagina=${itensPorPagina}&termo=${encodeURIComponent(parametroBusca.trim())}`,
                { headers: headers }
            );
        } else {
            return this.buscarReembolsos(idCliente, pagina, itensPorPagina);
        }
    }
}
